/**
 * Translation keys of the server's stable tokens (batch 8 T14c). The API returns tokens, never text; the portal maps
 * each known token to a key of the `inventoryReports` namespace and a token it does not know to `*.unknown`, so a
 * new server token shows a neutral label (never a raw key, never an id) until it is translated.
 */

/** `UnavailableReason` of the analytics core. */
export const UNAVAILABLE_REASONS = [
  'no_history',
  'pre_baseline',
  'no_layers',
  'cost_unconfirmed',
  'zero_denominator',
  'insufficient_sample',
  'no_expected_date',
  'no_quality_observation',
  'no_receipt_evidence',
  'no_revenue_identity',
  'orphan_consumption',
  'direct_sale_no_revenue',
  'not_invoiced',
  'invoice_reversed',
  'historical_stock_not_reconstructable',
  'before_history_start',
  'zero_window_usage',
  'age_unavailable',
  'mixed_streams',
  'completion_time_unavailable',
] as const;

export const STATUS_REASONS = ['no_consumption_history', 'age_unavailable', 'zero_window_usage'] as const;
export const PROFIT_KINDS = ['line', 'orphan', 'direct_sale'] as const;
export const COST_STATUSES = ['confirmed', 'unconfirmed', 'known', 'unknown'] as const;
export const CHANGE_TYPES = ['create', 'update', 'delete', 'import', 'sync', 'manual', 'initial'] as const;

const known = (list: readonly string[], value: string): boolean => list.includes(value);

export const reasonKey = (reason: string): string => (known(UNAVAILABLE_REASONS, reason) ? `reasons.${reason}` : 'reasons.unknown');
export const statusReasonKey = (reason: string): string => (known(STATUS_REASONS, reason) ? `statusReasons.${reason}` : 'statusReasons.unknown');
export const profitKindKey = (kind: string): string => (known(PROFIT_KINDS, kind) ? `profitKinds.${kind}` : 'profitKinds.unknown');
export const costStatusKey = (status: string): string => (known(COST_STATUSES, status) ? `costStatuses.${status}` : 'costStatuses.unknown');
export const changeTypeKey = (type: string): string => (known(CHANGE_TYPES, type) ? `changeTypes.${type}` : 'changeTypes.unknown');
